import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = ["part"]
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "container-fluid" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "container-fluid" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "d-sm-none" }
const _hoisted_8 = {
  key: 0,
  class: "d-flex justify-content-end mb-3"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "container-fluid" }, "Aliases view here", -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InjectStyles = _resolveComponent("InjectStyles")!
  const _component_CatalogsNotifications = _resolveComponent("CatalogsNotifications")!
  const _component_CatalogProductSwitch = _resolveComponent("CatalogProductSwitch")!
  const _component_CatalogsSearchForm = _resolveComponent("CatalogsSearchForm")!
  const _component_CatalogsSearchToolbar = _resolveComponent("CatalogsSearchToolbar")!
  const _component_CatalogsSearchTable = _resolveComponent("CatalogsSearchTable")!
  const _component_CatalogsSearchPagination = _resolveComponent("CatalogsSearchPagination")!
  const _component_ProductsBreadcrumbs = _resolveComponent("ProductsBreadcrumbs")!
  const _component_ProductsSearchProductCategories = _resolveComponent("ProductsSearchProductCategories")!
  const _component_ProductsSearchPartCategories = _resolveComponent("ProductsSearchPartCategories")!
  const _component_ProductsSearchFilters = _resolveComponent("ProductsSearchFilters")!
  const _component_ProductsSearchForm = _resolveComponent("ProductsSearchForm")!
  const _component_ProductsSearchToolbar = _resolveComponent("ProductsSearchToolbar")!
  const _component_ProductsSearchFiltersStatus = _resolveComponent("ProductsSearchFiltersStatus")!
  const _component_ProductsSearchTable = _resolveComponent("ProductsSearchTable")!
  const _component_ProductsTableView = _resolveComponent("ProductsTableView")!
  const _component_ProductsSearchList = _resolveComponent("ProductsSearchList")!
  const _component_ProductsListView = _resolveComponent("ProductsListView")!
  const _component_ProductsSearchGrid = _resolveComponent("ProductsSearchGrid")!
  const _component_ProductsGridView = _resolveComponent("ProductsGridView")!
  const _component_ProductsSearchNoResults = _resolveComponent("ProductsSearchNoResults")!
  const _component_ProductsSearchPagination = _resolveComponent("ProductsSearchPagination")!
  const _component_ProductsPreviewView = _resolveComponent("ProductsPreviewView")!
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")!
  const _component_CatalogActionModals = _resolveComponent("CatalogActionModals")!
  const _component_CatalogProductActionModals = _resolveComponent("CatalogProductActionModals")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "root",
    class: _normalizeClass(["pis-component position-relative", _ctx.componentName]),
    part: _ctx.componentName
  }, [
    _withDirectives(_createElementVNode("div", null, [
      (_ctx.isWebComponent)
        ? (_openBlock(), _createBlock(_component_InjectStyles, {
            key: 0,
            items: _ctx.store?.options.styles
          }, null, 8, ["items"]))
        : _createCommentVNode("", true),
      _createVNode(_component_CatalogsNotifications),
      _createVNode(_component_LoadingIndicator, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_CatalogProductSwitch)
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_CatalogsSearchForm),
              _createVNode(_component_CatalogsSearchToolbar),
              _hoisted_4,
              _createVNode(_component_CatalogsSearchTable),
              _createVNode(_component_CatalogsSearchPagination)
            ])
          ], 512), [
            [_vShow, _ctx.routeData?.view === 'catalogs']
          ]),
          _withDirectives(_createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_ProductsBreadcrumbs),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", {
                  class: _normalizeClass([_ctx.widerThan('xl') ? 'col-3' : _ctx.widerThan('md') ? 'col-4' : 'col-12'])
                }, [
                  _withDirectives(_createElementVNode("div", _hoisted_7, "Mobile view", 512), [
                    [_vShow, _ctx.allowMobileView]
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass([_ctx.allowMobileView && 'd-none d-sm-block'])
                  }, [
                    _createVNode(_component_ProductsSearchProductCategories),
                    _createVNode(_component_ProductsSearchPartCategories),
                    _createVNode(_component_ProductsSearchFilters)
                  ], 2)
                ], 2),
                _createElementVNode("div", {
                  class: _normalizeClass([_ctx.widerThan('xl') ? 'col-9' : _ctx.widerThan('md') ? 'col-8' : 'col-12'])
                }, [
                  false
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("a", {
                          href: "",
                          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
                          class: "btn btn-outline-primary"
                        }, _toDisplayString(_ctx.t('Import')), 1),
                        _createElementVNode("a", {
                          href: "",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                          class: "btn btn-primary ms-2"
                        }, _toDisplayString(_ctx.t('Export')), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_ProductsSearchForm),
                  _createVNode(_component_ProductsSearchToolbar),
                  _createVNode(_component_ProductsSearchFiltersStatus),
                  _createVNode(_component_ProductsTableView, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ProductsSearchTable)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ProductsListView, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ProductsSearchList)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ProductsGridView, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ProductsSearchGrid)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ProductsSearchNoResults),
                  _createVNode(_component_ProductsSearchPagination),
                  _createVNode(_component_ProductsPreviewView)
                ], 2)
              ])
            ])
          ], 512), [
            [_vShow, _ctx.routeData?.view === 'products']
          ]),
          _withDirectives(_createElementVNode("div", null, _hoisted_10, 512), [
            [_vShow, _ctx.routeData?.view === 'aliases']
          ])
        ]),
        _: 1
      })
    ], 512), [
      [_vShow, _ctx.isReady]
    ]),
    _createVNode(_component_CatalogActionModals, {
      t: _ctx.t,
      "instance-id": _ctx.instanceId
    }, null, 8, ["t", "instance-id"]),
    _createVNode(_component_CatalogProductActionModals, {
      t: _ctx.t,
      "instance-id": _ctx.instanceId
    }, null, 8, ["t", "instance-id"])
  ], 10, _hoisted_1))
}